import payacaLoaderGif from './payaca-loader.gif';

const Loader = () => {
  return (
    <img className="w-20" src={payacaLoaderGif} alt="payaca loading icon" />
  );
};

export default Loader;
